import { createAsyncThunk } from '@reduxjs/toolkit'
import { ServiceConfig } from '../services/config'
import { APIError, get, post, put } from '../services/crud'
import {
  INotification,
  INotificationDTO,
  INotificationUpdate,
  notificationDTOToEntity,
} from './typings'

const baseUrl = `${ServiceConfig.baseAPIUrl}/NotificationSettings`

export const getNotifications = createAsyncThunk<
  INotification[],
  void,
  { rejectValue: APIError }
>('notifications/get', async (_, thunkApi) => {
  const response = await get(baseUrl)
  if (response.ok) {
    const payload: INotificationDTO[] = await response.json()

    const result = payload.map<INotification>((notif) =>
      notificationDTOToEntity(notif),
    )
    return result
  }
  return thunkApi.rejectWithValue(await response.json())
})

export const toggleNotification = createAsyncThunk<
  number,
  number,
  { rejectValue: APIError }
>('notifications/toggle', async (id, thunkApi) => {
  const response = await post(`${baseUrl}/${id}/toggle`)
  if (response.ok) return id
  return thunkApi.rejectWithValue(await response.json())
})

export const updateNotification = createAsyncThunk<
  INotification,
  INotificationUpdate,
  { rejectValue: APIError }
>('notifications/update', async (notification, thunkApi) => {
  const response = await put(baseUrl, notification)
  if (response.ok) {
    const result: INotificationDTO = await response.json()
    return notificationDTOToEntity(result)
  }
  return thunkApi.rejectWithValue(await response.json())
})
